import SiteRender from './core/components/render/siteRender'
import { MICRO_SITE_TYPE } from '@/constant/common'
import { mapActions } from 'vuex'
import { deviceType } from '@/utils/common'
import { configWeComShare, configWxShareOnMicroSite } from '@/utils/wxShareConfig'

export default {
  extends: SiteRender,
  data () {
    return {
      weComAppInfo: null,
      shareConfig: {}
    }
  },
  computed: {
    type () {
      return MICRO_SITE_TYPE.crm
    }
  },
  created () {
    this.pathPrefix = `/microsite/crm/${this.siteId}`
    this.init()
  },
  methods: {
    ...mapActions('common', ['getWxApiTicket']),
    async init () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.initSitePages()
        if (resp) {
          this.shareConfig = resp.originResponse.wechat_share_config
          this.weComAppInfo = resp.originResponse.wecom_app_info
          await this.configWxShare()
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async configWxShare () {
      if (!deviceType.isWeChat || (deviceType.isWeChatWork && !this.weComAppInfo)) {
        return
      }
      const shareConfig = this.shareConfig
      let shareLink = window.location.href
      if (this.account?.id || this.softUser?.id) {
        const micrositeShortId = this.siteId
        shareLink = await this.startListReferral({ micrositeShortId })
        shareLink = window.location.origin + shareLink
      }
      if (deviceType.isWeChatWork) {
        configWeComShare(this.weComAppInfo, {
          title: shareConfig.friendsTitle,
          moment_title: shareConfig.momentsTitle,
          description: shareConfig.description,
          image_url: shareConfig.imageUrl,
          link: shareLink
        })
      } else {
        const shareImageUrl = shareConfig.imageUrl
        if (!shareImageUrl.includes('http')) {
          shareConfig.imageUrl = `${process.env.VUE_APP_QINIU_DOMAIN}${shareImageUrl}`
        }
        const appMessageShareData = {
          title: shareConfig.friendsTitle,
          desc: shareConfig.description,
          link: shareLink,
          imgUrl: shareConfig.imageUrl
        }
        const timelineShareData = {
          ...appMessageShareData,
          title: shareConfig.momentsTitle
        }
        await configWxShareOnMicroSite(appMessageShareData, timelineShareData, this.company.root_company?.id)
      }
    },
    handleResponseError (errorResp) {
      if (errorResp.code === 20002005) {
        this.$router.replace(`/error/internal-only/microsite?from=${this.siteId}&type=microsite`)
      } else if (errorResp.code === 20002010) {
        this.$router.replace(`/error/internal-only/microsite?from=${this.siteId}&type=microsite&inactive=true`)
      }
    }
  },
  watch: {
    async $route () {
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.configWxShare()
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
